import {
  Truck,
  Database,
  Briefcase,
  Layout,
  User,
  Package,
  DollarSign,
} from "react-feather";
const permissions = localStorage.getItem("permissions");
export const MENUITEMS = [
  permissions === "ROLE_ADMIN" && {
    menutitle: "Administrador",
    menucontent: "Páginas de Administração",
    Items: [
      permissions === "ROLE_ADMIN" && {
        title: "Administradores",
        icon: User,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/administradores/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Empresas",
        icon: Briefcase,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/empresas/listar`,
        // children: [
        //   {
        //     path: `${process.env.PUBLIC_URL}/empresas/cadastrar`,
        //     title: "Cadastrar Empresa",
        //     type: "link",
        //   },
        //   {
        //     path: `${process.env.PUBLIC_URL}/empresas/listar`,
        //     title: "Lista Empresa",
        //     type: "link",
        //   },
        // ],
      },
      permissions === "ROLE_ADMIN" && {
        title: "Veículos",
        icon: Truck,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/veiculos/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Tambores",
        icon: Database,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/tambores/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Contratos",
        icon: Layout,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/contratos/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Motoristas",
        icon: User,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/motoristas/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Coletas",
        icon: Package,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/coletas/listar`,
      },
      permissions === "ROLE_ADMIN" && {
        title: "Cobranças",
        icon: DollarSign,
        type: "sub",
        active: false,
        path: `${process.env.PUBLIC_URL}/cobrancas/listar`,
        children: [
          {
            path: `${process.env.PUBLIC_URL}/cobrancas/extrato`,
            title: "Extrato",
            type: "link",
          },
        ],
      },
    ],
  },
];
